import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { Task } from '../../../domain/task';
import { DateLocalFormatPipe } from '../../../pipes/date-local-format.pipe';

@Component({
   selector: 'app-unclaimed-tasks',
   standalone: true,
   imports: [
      CommonModule,
      TableModule,
      ButtonModule,
      CheckboxModule,
      ProgressSpinnerModule,
      DateLocalFormatPipe
   ],
   templateUrl: './my-unclaimed-tasks.component.html',
   styleUrls: ['./my-unclaimed-tasks.component.scss']
})
export class MyUnclaimedTasksComponent {
   @Input() unclaimedTasks: Task[] = [];
   @Input() isLoading = false;
   @Input() isClaiming = false;

   @Output() claimTasksEvent = new EventEmitter<Task[]>();

   selectedTasks: Task[] = [];

   claimSelectedTasks(): void {
      if (this.selectedTasks.length === 0) {
         return;
      }

      this.claimTasksEvent.emit(this.selectedTasks);
      this.selectedTasks = [];
   }

   getTaskClass(taskType: number): string {
      switch (taskType) {
         case 0:
            return 'schedule-tag-daily';
         case 1:
            return 'schedule-tag-non-daily';
         case 2:
            return 'schedule-tag-private';
         case 3:
            return 'schedule-tag-contracts';
         case 4:
            return 'schedule-tag-form';
         default:
            return 'schedule-tag-daily';
      }
   }

   handleTaskType(taskType: number): string {
      switch (taskType) {
         case 0:
            return 'Daily';
         case 1:
            return 'Non-daily';
         case 2:
            return 'Private';
         case 3:
            return 'Contracts';
         case 4:
            return 'Form';
         default:
            return 'Daily';
      }
   }
}
